__turbopack_context__.v({
  "chevron": "FallbackRowItem-module__pb2nhq__chevron" + " " + __turbopack_context__.i(524956)["chevron"],
  "content": "FallbackRowItem-module__pb2nhq__content" + " " + __turbopack_context__.i(524956)["content"],
  "item": "FallbackRowItem-module__pb2nhq__item" + " " + __turbopack_context__.i(524956)["item"],
  "itemActive": "FallbackRowItem-module__pb2nhq__itemActive" + " " + __turbopack_context__.i(524956)["itemActive"],
  "spinner": "FallbackRowItem-module__pb2nhq__spinner" + " " + __turbopack_context__.i(524956)["spinner"],
  "thumbnail": "FallbackRowItem-module__pb2nhq__thumbnail" + " " + __turbopack_context__.i(524956)["thumbnail"],
  "thumbnailIcon": "FallbackRowItem-module__pb2nhq__thumbnailIcon" + " " + __turbopack_context__.i(524956)["thumbnailIcon"],
  "thumbnailImg": "FallbackRowItem-module__pb2nhq__thumbnailImg" + " " + __turbopack_context__.i(524956)["thumbnailImg"],
  "title": "FallbackRowItem-module__pb2nhq__title" + " " + __turbopack_context__.i(524956)["title"],
});
